import React from 'react';
import styled from 'styled-components';
import { IconSearch, IconSmart } from '@bynder/icons';

interface Props {
	isPerformingNLSSearch: boolean;
}

export function SearchIcon({ isPerformingNLSSearch }: Props) {
	return (
		<StyledSpan>
			{isPerformingNLSSearch ? <IconSmart size="22px" /> : <IconSearch size="22px" />}
		</StyledSpan>
	);
}

const StyledSpan = styled.span`
	position: absolute;
	top: 50%;
	left: 0px;
	transform: translateY(-50%);
	padding-left: 10px;
`;
